/**
 * Development standards — the metric rules AlderCAD reads (Supabase `development_standards`,
 * database/286, api/development-standards.js). A zone's or overlay's height limits; an HOA's
 * height limit by lot. Shared research: one rule serves every parcel on that zone or HOA.
 * See docs/DEVELOPMENT_STANDARDS.md.
 */

async function post(payload) {
  const headers = { 'Content-Type': 'application/json' }
  if (typeof window !== 'undefined' && typeof window.__clerkGetToken === 'function') {
    try { const t = await window.__clerkGetToken(); if (t) headers['Authorization'] = 'Bearer ' + t } catch { /* unauthed */ }
  }
  const res = await fetch('/api/development-standards', { method: 'POST', headers, body: JSON.stringify(payload) })
  const data = await res.json().catch(() => ({ error: 'Bad response from /api/development-standards' }))
  if (!res.ok || data.error) throw new Error(data.error || ('Request failed (' + res.status + ')'))
  return data
}

/** 'zone' (a zone or special overlay record) | 'organization' (an HOA) */
export async function listHeightRules(sourceKind, sourceId) {
  return (await post({ action: 'list', sourceKind, sourceId })).rules || []
}

/** create (no id) or update a rule; returns the saved row */
export async function saveHeightRule(rule, byName) {
  return (await post({ action: 'save', rule, byName })).rule
}

export async function deleteHeightRule(id) {
  await post({ action: 'delete', id })
}

/** a jurisdiction's demolition (major remodel) rules, confirmed or not (database/296) */
export async function listDemolitionRules(jurisdictionId) {
  return (await post({ action: 'listDemolition', sourceId: jurisdictionId })).rules || []
}

/** confirm (or un-confirm) a demolition rule — only a confirmed rule prints on a sheet */
export async function confirmDemolitionRule(id, confirmed, byName) {
  return (await post({ action: 'confirmDemolition', id, confirmed, byName })).rule
}

/** required-parking rules on a zone or jurisdiction (database/313) — at most one each */
export async function listParkingRules(sourceKind, sourceId) {
  return (await post({ action: 'listParking', sourceKind, sourceId })).rules || []
}
export async function saveParkingRule(rule, byName) {
  return (await post({ action: 'saveParking', rule, byName })).rule
}
export async function confirmParkingRule(id, confirmed, byName) {
  return (await post({ action: 'confirmParking', id, confirmed, byName })).rule
}
export async function deleteParkingRule(id) {
  await post({ action: 'delete', id })
}
